import * as L from 'leaflet';
import { Route, Segment } from '../../../models/segment';

export type MapType = 'generalized' | 'crowd';
export type Accessibility = 'SAFE' | 'UNSAFE' | 'OCCASIONALLY_UNSAFE';

export interface RegistryItem {
  polyline: L.Polyline;
  segment: Segment;
  route: Route;
  map: L.LayerGroup;
  mapType: MapType;
  accessibility: Accessibility;
}

export class Registry {
  items: RegistryItem[] = [];

  add(item: RegistryItem) {
    this.items.push(item);
    return this;
  }

  allPolylines(): L.Polyline[] | L.Edit.Polyline[] {
    return this.items.map(i => i.polyline);
  }

  closestLatlng(map: L.Map, poly: L.Polyline, latlng: L.LatLng, dist: number = 5) {

    const nearLatlng = L.GeometryUtil.closest(map, poly, latlng);
    const cDist = L.GeometryUtil.distance(map, nearLatlng, latlng);
    let inside = false;
    if ( cDist <= dist ) {
      console.log(cDist);
      inside = true;
    }

    return inside;
  }

  getByPolyline(polyline: L.Polyline): RegistryItem {
    return this.items.find(i => i.polyline === polyline);
  }

  getPolylinesByLatlng(map: L.Map, latlng: L.LatLng): RegistryItem[] {
    return this.items.filter(i => this.closestLatlng(map, i.polyline, latlng));
  }

  getByRoute(route: Route): RegistryItem {
    return this.items.find(i => i.route === route);
  }

  removePolylines(mapType: MapType, accessibility: Accessibility) {
    this.items = this.items.filter(i => {
      if (i.mapType === mapType && i.accessibility === accessibility) {
        i.map.removeLayer(i.polyline);
        return false;
      }
      return true;
    });
  }

  removePolyline(polyline: L.Polyline) {
    this.items = this.items.filter(i => {
      if (i.polyline === polyline) {
        i.map.removeLayer(i.polyline);
        return false;
      }
      return true;
    });
  }
}

export interface RoutingContainer {
  routing: L.Routing.Control;
  route: Route;
}

export interface ExtendRoutingContainer {
  routing: any;
  route: Route;
  segmentId: number;
  clickedRoute: Route;
  dragIdx: number;
}

export interface ExtendRoutingObj {
  start: {
    routeContainer: ExtendRoutingContainer,
    latlng: any,
    oldLatlng: any
  };
  main: {
    routeContainer: ExtendRoutingContainer,
    latlng: any,
    oldLatlng: any
  };
  end: {
    routeContainer: ExtendRoutingContainer,
    latlng: any,
    oldLatlng: any
  }
  ;
}

export interface SelectedSegment {
  polyline: L.Polyline;
  route: Route;
  segmentId: number;
  orgColor: Accessibility;
  chosenColor: Accessibility;
  extendRoutings: ExtendRoutingObj;
}
